import { getLocale } from "../runtime";

const da_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Tak for din ordre, ${inputs.name}!`
};

const en_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Thank you for your order, ${inputs.name}!`
};

const es_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `¡Gracias por tu pedido, ${inputs.name}!`
};

const fi_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Kiitos tilauksestasi, ${inputs.name}!`
};

const nb_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Takk for bestillingen din, ${inputs.name}!`
};

const sv_thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}) => string} */ (inputs) => {
	return `Tack för din beställning, ${inputs.name}!`
};

const thankyoufororder = /** @type {(inputs: {name: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_thankyoufororder(inputs)
	if (locale === "en") return en_thankyoufororder(inputs)
	if (locale === "es") return es_thankyoufororder(inputs)
	if (locale === "fi") return fi_thankyoufororder(inputs)
	if (locale === "nb") return nb_thankyoufororder(inputs)
	if (locale === "sv") return sv_thankyoufororder(inputs)
	return "thankYouForOrder";
};

export { thankyoufororder as "thankYouForOrder" };